module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "favourites"
  }, [_c('header-bar'), _vm._v(" "), (!_vm.uiHideInstructions) ? _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chunkArrayLength),
      expression: "chunkArrayLength"
    }],
    staticClass: "instructions background-image"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "vertical-align"
  }, [_c('h3', [_vm._v("These are all the people you've favourited. Chat now or start a conversation later.")]), _vm._v(" "), _c('a', {
    staticClass: "link-simple",
    on: {
      "click": _vm.hideInstructions
    }
  }, [_vm._v("Close")])])])])]) : _vm._e(), _vm._v(" "), (_vm.chunkArrayLength) ? _c('section', {
    staticClass: "matches",
    class: {
      noinstructions: _vm.uiHideInstructions
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(user, key) {
      return _c('user-box', {
        key: key,
        attrs: {
          "userid": user,
          "metadisplay": _vm.favourites
        }
      })
    }))
  }))]) : (!_vm.chunkArrayLength) ? _c('section', {
    staticClass: "page-empty"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-align"
  }, [_c('h4', [_vm._v("You haven't favourited anyone yet. View your "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Matches")]), _vm._v(" to find some interesting people.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-round green",
    attrs: {
      "to": "matches"
    }
  }, [_vm._v("View Matches")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90620f5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Favourites.vue
// module id = 725
// module chunks = 1